<template>
  <div>
    <nav-bar :title="navBarTitle" />
    <div class="mobile pt-4">
      <b-container>
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <my-projects-skeleton></my-projects-skeleton>
          </template>
          <div>
            <project-listing v-if="Projects.length" :projects="Projects"></project-listing>
            <no-projects-view v-else></no-projects-view>
            <b-button
              @click="redirectTo('createNewProject')"
              pill
              class="bg-main font-weight-bolder float-button-right rounded-circle p-1"
            >
              <i class="material-icons big-icon align-middle">add</i>
            </b-button>
          </div>
        </b-skeleton-wrapper>
      </b-container>
    </div>
  </div>
</template>

<script>
import { getAllProjects } from '@/myTasks/services/';
import { useSessionStore } from '@/common';
import { NavBar } from '@/common/components';
import MyProjectsSkeleton from '@/myTasks/components/skeletons/MyProjectsSkeleton';
import ProjectListing from '@/myTasks/components/ProjectListing';
import NoProjectsView from '@/myTasks/views/NoProjectsView';
import notificationToastMixin from '@/Mixins/notificationToast.mixin';

export default {
  components: {
    NavBar,
    MyProjectsSkeleton,
    ProjectListing,
    NoProjectsView,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      loading: true,
      sessionStore,
      Projects: [],
    };
  },
  computed: {
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    navBarTitle() {
      return this.userIsAParent ? `${this.childSelectedName}'s Project` : 'My Projects';
    },
    getChildId() {
      return this.userIsAParent ? this.sessionStore.childSelectedId : this.sessionStore.userId;
    },
    childSelectedName() {
      return this.sessionStore.childName;
    },
    parentCanEdit() {
      return this.sessionStore.getCurrentChild.parentCanEdit;
    },
  },
  mixins: [notificationToastMixin],
  methods: {
    redirectTo(route) {
      if (this.userIsAParent && !this.parentCanEdit) {
        this.readOnlyUserNotificationToast();
        return;
      }
      this.$router.push({ name: route });
    },
  },
  async mounted() {
    this.loading = true;
    try {
      this.Projects = await getAllProjects(this.getChildId);
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  },
};
</script>
